// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"abc272f7","633":"c96c6e52","816":"f1f51636"}[chunkId] + ".chunk.js";
};